import { css } from '@emotion/core';
import { styled, minimumWidth, pxToRem, Text } from '@feast-it/ui/light';

export const TestimonialQuoteContainer = styled.div(
  ({ theme }) => css`
    position: relative;
    margin-top: ${pxToRem(10)};
    padding: ${theme.spacing[7]} ${theme.spacing[5]};
    border-radius: ${theme.radii[2]};
    background: ${theme.colors.white};
    width: 100%;

    ${minimumWidth(theme.breakpoints.large)} {
      margin-top: 0;
      padding-left: ${theme.spacing[9]};
    }

    &::before {
      content: '“';
      position: absolute;
      top: ${pxToRem(-22)};
      left: 50%;
      font-size: ${pxToRem(100)};
      color: ${theme.colors.mediumBlue};
      transform: translateX(-50%);

      ${minimumWidth(theme.breakpoints.large)} {
        top: ${theme.spacing[6]};
        left: 0;
      }
    }
  `
);

export const Content = styled.blockquote`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledQuote = styled(Text)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing[3]};
  `
);

export const StarsWrapper = styled.span(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacing[1]};
  `
);

export const CustomerDetailsWrapper = styled.span(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-top: ${theme.spacing[6]};
  `
);

export const AvatarWrapper = styled.span(
  ({ theme }) => css`
    margin-right: ${theme.spacing[4]};
    flex-shrink: 0;
  `
);

export const CustomerText = styled.span(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacing[1]};
  `
);
